import { useEffect } from 'react';

import {
	useAvailableSitesState,
	useProjectsState,
	useMappingsActions,
} from '../providers/BulkConfigureContextProvider.tsx';
import { useBulkCreateLoggingEvents } from '../utils/useBulkCreateLoggingEvents.tsx';

import { fetchJiraComponents } from './apiUtils.ts';

export const FETCH_PROJECT_COMPONENTS = 'fetch-project-components';

export const useGetJiraProjectComponents = (): void => {
	const { logRequestFailed } = useBulkCreateLoggingEvents();

	const { selectedAvailableSite } = useAvailableSitesState();
	const { selectedProject } = useProjectsState();
	const { setMappingAvailableComponents } = useMappingsActions();

	useEffect(() => {
		const cloudId = selectedAvailableSite?.cloudId;
		const projectId = selectedProject?.id;
		if (!cloudId || !projectId) {
			return;
		}

		const fetchComponents = async () => {
			try {
				const components = await fetchJiraComponents({ cloudId, projectId });
				setMappingAvailableComponents(components ?? []);
			} catch (error: Error | unknown) {
				logRequestFailed({
					requestName: FETCH_PROJECT_COMPONENTS,
					errorMessage: (error as Error).message,
				});
			}
		};
		void fetchComponents();
	}, [selectedAvailableSite, selectedProject, logRequestFailed, setMappingAvailableComponents]);
};
